import * as React from "react";

const CredentialInvitationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M10.5 17.25a.75.75 0 1 0 0-1.5H3a.75.75 0 0 1-.75-.75V5.805l7.114 4.151a2.27 2.27 0 0 0 2.267 0l7.119-4.153V9a.75.75 0 1 0 1.5 0V4.5A2.25 2.25 0 0 0 18 2.25H3a2.25 2.25 0 0 0-1.837.962A2.3 2.3 0 0 0 .75 4.5V15A2.25 2.25 0 0 0 3 17.25zM3 3.75h15a.74.74 0 0 1 .639.381l-7.764 4.53a.76.76 0 0 1-.755 0L2.36 4.134A.74.74 0 0 1 3 3.75"
    ></path>
    <path
      fill="#000"
      d="M18 11.25a5.25 5.25 0 1 0 0 10.5.75.75 0 1 0 0-1.5 3.75 3.75 0 1 1 3.75-3.75v.75a.75.75 0 1 1-1.5 0v-.75A2.25 2.25 0 1 0 18 18.75a2.2 2.2 0 0 0 1.102-.3 2.245 2.245 0 0 0 4.148-1.2v-.75A5.256 5.256 0 0 0 18 11.25m0 6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
    ></path>
  </svg>
);

export default CredentialInvitationIcon;
